export default __webpack_public_path__ + "static/media/Metropolis-Medium.2fa651ef.ttf";